import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem('token');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('adminUsername');
    navigate('/login');
  };

  return (
    <>
     

      {/* Nav Bar Start */}
      <div className="nav-bar">
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg navbar-dark">
            <Link to="#" className="navbar-brand">MENU</Link>
            <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
              <div className="navbar-nav mr-auto">
                <Link to="/" className="nav-item nav-link">Home</Link>
                <Link to="/about" className="nav-item nav-link">About Us</Link>
                <div className="nav-item dropdown">
                  <Link to="#" className="nav-link dropdown-toggle" data-toggle="dropdown">Our Services</Link>
                  <div className="dropdown-menu">
                    <div className="row">
                      <div className="col-md-3">
                        <Link to="/services/bim" className="dropdown-item">BIM Service</Link>
                        <Link to="/services/engineering-consultation" className="dropdown-item">Engineering Consultation</Link>
                        <Link to="/services/structural-engineering" className="dropdown-item">Structural Engineering</Link>
                      </div>
                      <div className="col-md-3">
                        <Link to="/services/offshore" className="dropdown-item">OffShore Services</Link>
                        <Link to="/services/process-plant" className="dropdown-item">Process Plant</Link>
                        <Link to="/services/manufacturing-supply" className="dropdown-item">Manufacturing and Supply</Link>
                      </div>
                    </div>
                  </div>
                </div>
                <Link to="/projects" className="nav-item nav-link">Projects</Link>
                <Link to="/certificates" className="nav-item nav-link">Certificates</Link>
                <Link to="/careers" className="nav-item nav-link">Careers</Link>
                <Link to="/contact" className="nav-item nav-link">Contact Us</Link>
              </div>
              <div className="nav-auth">
                {isAdmin ? (
                  <>
                    <Link to="/dashboard" className="nav-item nav-link">Dashboard</Link>
                    <button onClick={handleLogout} className="nav-item nav-link logout-btn">Logout</button>
                  </>
                ) : (
                  <Link to="/login" className="nav-item nav-link">Admin Login</Link>
                )}
              </div>
            </div>
          </nav>
        </div>
      </div>
      {/* Nav Bar End */}
    </>
  );
};

export default Navbar;